<div class="container power-bi-container">
  <div class="controls vh-75">
    <powerbi-report [embedConfig]="reportConfig" [cssClassName]="'powerbi-report'" *ngIf="reportConfig.accessToken"></powerbi-report>
  </div>
</div>